/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-param-reassign */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import BaseChannelSerializer from '@square/dashboard-data/serializers/channels/base-channel-serializer';
import { ERROR_TYPE, WARNING_FIELD, VALIDATION_FIELD } from '@square/dashboard-data/models/channels/object-map-acknowledgment-error';
export const ERROR_PROBLEM_MAPPING = {
  'Currency is required': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.required.currency',
    errorType: ERROR_TYPE.ERROR,
    fields: [VALIDATION_FIELD.CURRENCY]
  },
  'Description is required': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.required.description',
    errorType: ERROR_TYPE.ERROR,
    fields: [VALIDATION_FIELD.DESCRIPTION]
  },
  'DisplayName is required': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.required.displayName',
    errorType: ERROR_TYPE.ERROR,
    fields: [VALIDATION_FIELD.DISPLAY_NAME]
  },
  'URI is required': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.required.uri',
    errorType: ERROR_TYPE.ERROR,
    fields: [VALIDATION_FIELD.URI]
  },
  'ImageURIs is required': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.required.imageUri',
    errorType: ERROR_TYPE.ERROR,
    fields: [VALIDATION_FIELD.IMAGE_URIS]
  },
  'Amount must be greater than 0': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.greaterThan.amount',
    errorType: ERROR_TYPE.ERROR,
    fields: [VALIDATION_FIELD.PRICE]
  },
  'ImageURIs must be greater than 0': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.greaterThan.imageUri',
    errorType: ERROR_TYPE.ERROR,
    fields: [VALIDATION_FIELD.IMAGE_URIS]
  },
  'Description must be less than 5000 characters': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.lessThan.description',
    errorType: ERROR_TYPE.ERROR,
    fields: [VALIDATION_FIELD.DESCRIPTION]
  },
  'DisplayName must be less than 150 characters': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.lessThan.displayName',
    errorType: ERROR_TYPE.ERROR,
    fields: [VALIDATION_FIELD.DISPLAY_NAME]
  },
  'GTIN is not valid': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.moreThan.gtin',
    errorType: ERROR_TYPE.ERROR,
    fields: [WARNING_FIELD.UPC]
  },
  'URI does not match expected uri host value': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.doesNotMatch.uri',
    errorType: ERROR_TYPE.ERROR,
    fields: [VALIDATION_FIELD.URI]
  },
  'Product is invalid or is suspended due to policy violations': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.policyViolation',
    errorType: ERROR_TYPE.ERROR,
    fields: []
  },
  'Incorrect value [identifier exists]. This item has an internationally recognized, unique identifier. Submit a valid GTIN, and either set this value to true or remove this value.': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.invalidGtin',
    errorType: ERROR_TYPE.ERROR,
    fields: [WARNING_FIELD.UPC]
  },
  "Unsupported value due to restrictions: GTIN [gtin]. Use a GTIN that's not restricted; GS1 hasn't released the current value yet": {
    translationKey: 'channelListings.listingNotification.listingError.errorType.invalidGtin',
    errorType: ERROR_TYPE.ERROR,
    fields: [WARNING_FIELD.UPC]
  },
  "Invalid value [gtin]. Submit a valid value based on Google's product data specification": {
    translationKey: 'channelListings.listingNotification.listingError.errorType.invalidGtin',
    errorType: ERROR_TYPE.ERROR,
    fields: [WARNING_FIELD.UPC]
  },
  'GTIN not related to brand. Use a globally valid GTIN that is related to the brand you submitted': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.invalidGtin',
    errorType: ERROR_TYPE.ERROR,
    fields: [WARNING_FIELD.UPC]
  },
  'Unsupported value (reserved) [gtin]. Use a GTIN that doesn\'t start with "2", "02", or "04"': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.invalidGtin',
    errorType: ERROR_TYPE.ERROR,
    fields: [WARNING_FIELD.UPC]
  },
  'Duplicate value [gtin]. Submit a unique value for each product': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.duplicateGtin',
    errorType: ERROR_TYPE.ERROR,
    fields: [WARNING_FIELD.UPC]
  },
  'Invalid home page link. Claim your website in Merchant Center': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.invalidHomePage',
    errorType: ERROR_TYPE.ERROR,
    fields: []
  },
  'Missing value [tax]. Add tax information in your Merchant Center settings or in your product data': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.missingValueTax',
    errorType: ERROR_TYPE.ERROR,
    fields: []
  },
  'Missing value [shipping]. Add shipping costs for your product': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.missingValueShipping',
    errorType: ERROR_TYPE.ERROR,
    fields: []
  },
  'Generic image. Use an image that shows the product': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.genericImage',
    errorType: ERROR_TYPE.ERROR,
    fields: [VALIDATION_FIELD.IMAGE_URIS]
  },
  'Image size must be at least 500 x 500 pixels': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.imageSize',
    errorType: ERROR_TYPE.ERROR,
    fields: [VALIDATION_FIELD.IMAGE_URIS]
  },
  'Image too big. Use an image that has a resolution less than 64 megapixels and file size smaller than 16MB': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.imageSize',
    errorType: ERROR_TYPE.ERROR,
    fields: [VALIDATION_FIELD.IMAGE_URIS]
  },
  'Image uses a single color [image link]. A single-color image can only be used for specific types of products. Update the image to better reflect the product, then resubmit your feed.': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.imageColor',
    errorType: ERROR_TYPE.ERROR,
    fields: [VALIDATION_FIELD.IMAGE_URIS]
  },
  'Image too small. Upload an image (JPG, PNG, GIF) that is at least 250x250 pixels.': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.imageTooSmall',
    errorType: ERROR_TYPE.ERROR,
    fields: [VALIDATION_FIELD.IMAGE_URIS]
  },
  'Violation of Shopping ads policy. Review Shopping ads policies and update your feed to meet the requirements': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.shoppingAdsViolation',
    errorType: ERROR_TYPE.ERROR,
    fields: []
  },
  'Invalid landing page link. Update your website or landing page URL to enable access from desktop devices': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.landingPage',
    errorType: ERROR_TYPE.ERROR,
    fields: []
  },
  'Invalid mobile landing page link. Update your website or landing page URL to enable access from mobile devices': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.landginPageMobile',
    errorType: ERROR_TYPE.ERROR,
    fields: []
  },
  'Invalid value [gtin]. Use a globally valid UPC': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.invalidGtin',
    errorType: ERROR_TYPE.ERROR,
    fields: [WARNING_FIELD.UPC]
  },
  'Brand is required': {
    translationKey: 'channelListings.listingNotification.listingError.errorType.required.brand',
    errorType: ERROR_TYPE.ERROR,
    fields: [WARNING_FIELD.BRAND]
  },
  'Text too short [description]': {
    translationKey: 'channelListings.listingNotification.listingError.warningType.textTooShort.description',
    errorType: ERROR_TYPE.WARNING,
    fields: [WARNING_FIELD.DESCRIPTION]
  },
  'Limited performance due to missing identifiers [gtin, mpn, brand]': {
    translationKey: 'channelListings.listingNotification.listingError.warningType.missingValue.missingIdentifiers',
    errorType: ERROR_TYPE.WARNING,
    fields: [WARNING_FIELD.UPC, WARNING_FIELD.MPN, WARNING_FIELD.BRAND]
  },
  'Limited performance due to missing value [brand]': {
    translationKey: 'channelListings.listingNotification.listingError.warningType.missingValue.brand',
    errorType: ERROR_TYPE.WARNING,
    fields: [WARNING_FIELD.BRAND]
  },
  'Missing value [age group]': {
    translationKey: 'channelListings.listingNotification.listingError.warningType.missingValue.ageGroup',
    errorType: ERROR_TYPE.WARNING,
    fields: [WARNING_FIELD.AGE_GROUP]
  },
  'Missing value [color]': {
    translationKey: 'channelListings.listingNotification.listingError.warningType.missingValue.color',
    errorType: ERROR_TYPE.WARNING,
    fields: [WARNING_FIELD.COLOR]
  },
  'Missing value [gender]': {
    translationKey: 'channelListings.listingNotification.listingError.warningType.missingValue.gender',
    errorType: ERROR_TYPE.WARNING,
    fields: [WARNING_FIELD.GENDER]
  },
  'Missing value [size]': {
    translationKey: 'channelListings.listingNotification.listingError.warningType.missingValue.size',
    errorType: ERROR_TYPE.WARNING,
    fields: [WARNING_FIELD.SIZE]
  },
  'Limited performance due to missing ISBN or GTIN': {
    translationKey: 'channelListings.listingNotification.listingError.warningType.missingValue.gtinOrIsbn',
    errorType: ERROR_TYPE.WARNING,
    fields: [WARNING_FIELD.ISBN, WARNING_FIELD.UPC]
  },
  'Limited performance due to missing value [gtin]': {
    translationKey: 'channelListings.listingNotification.listingError.warningType.missingValue.gtin',
    errorType: ERROR_TYPE.WARNING,
    fields: [WARNING_FIELD.UPC]
  },
  'Invalid value [gtin]': {
    translationKey: 'channelListings.listingNotification.listingError.warningType.missingValue.gtin',
    errorType: ERROR_TYPE.WARNING,
    fields: [WARNING_FIELD.UPC]
  }
};
export default BaseChannelSerializer.extend(EmbeddedRecordsMixin, {
  modelNameFromPayloadKey() {
    return 'channels/object-map-acknowledgment-error';
  },
  normalize(typeClass, hash) {
    hash.translation_key = null;
    hash.fields = [];
    const error = ERROR_PROBLEM_MAPPING[hash.error_problem];
    if (!error) {
      return this._super(typeClass, hash);
    }
    hash.translation_key = error.translationKey;
    hash.fields = error.fields;
    return this._super(typeClass, hash);
  }
});